import './index.scss'

type SizeNumber = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9

type Props = {
  top?: SizeNumber | undefined
  right?: SizeNumber | undefined
  bottom?: SizeNumber | undefined
  left?: SizeNumber | undefined
  children: React.ReactNode
  style?: {}
}

// Generic block wrapper which adds margin to content
const Block = ({ top, bottom, left, right, children, ...rest }: Props) => {
  // We could replace this logic with something like https://www.npmjs.com/package/classnames
  const blockClass = [
    'block',
    top !== undefined && `block--top-${top}`,
    right !== undefined && `block--right-${right}`,
    bottom !== undefined && `block--bottom-${bottom}`,
    left !== undefined && `block--left-${left}`,
  ]
    .filter((classname) => classname !== false)
    .join(' ')

  return (
    <div className={blockClass} {...rest}>
      {children}
    </div>
  )
}

export default Block
